import { colors as akColors } from '@atlaskit/theme';
import {
  ADSRefresh2025Colors,
  type SelectOptionColor,
  SelectOptionColors
} from '@databases/model/field';
import { selectOptionColorValues } from '@databases/utils/database/field-types/select';

import { type ColorPalette } from './types.ts';

const hoverColors: Record<string, string> = {
  // Copied from @atlaskit/tag
  [akColors.N20]: akColors.N30,
  [akColors.B100]: akColors.B75,
  [akColors.R100]: akColors.R75,
  [akColors.Y200]: akColors.Y100,
  [akColors.G200]: akColors.G100,
  [akColors.T200]: akColors.T100,
  [akColors.P100]: akColors.P75,
  [akColors.N500]: akColors.N400,
  [akColors.B75]: akColors.B50,
  [akColors.R75]: akColors.R50,
  [akColors.Y100]: akColors.Y75,
  [akColors.G100]: akColors.G75,
  [akColors.T100]: akColors.T75,
  [akColors.P75]: akColors.P50,
  [akColors.N30]: akColors.N40,

  // Needed for dark select option colors
  [akColors.B400]: akColors.B300,
  [akColors.R400]: akColors.R300,
  [akColors.Y300]: akColors.Y200,
  [akColors.G400]: akColors.G300,
  [akColors.P400]: akColors.P300,

  // Needed for light select option colors
  [akColors.B50]: akColors.B75,
  [akColors.R50]: akColors.R75,
  [akColors.Y50]: akColors.Y75,
  [akColors.G50]: akColors.G75,
  [akColors.T50]: akColors.T75,
  [akColors.P50]: akColors.P75,
  [akColors.N40]: akColors.N60,

  // Additionally needed for page status colors
  [akColors.B200]: akColors.B100,
  [akColors.R200]: akColors.R100,
  [akColors.P200]: akColors.P100
};

export const TagColorPalette: ColorPalette<SelectOptionColor> = {
  borderColor: (colorName) => selectOptionColorValues[colorName][1],
  backgroundColor: (colorName) => selectOptionColorValues[colorName][0],
  textColor: (colorName) => selectOptionColorValues[colorName][1],
  hoverBackgroundColor: (colorName) => hoverColors[selectOptionColorValues[colorName][0]],
  swatch: () =>
    SelectOptionColors.filter((color) => !ADSRefresh2025Colors.includes(color))
};
